export default __webpack_public_path__ + "static/media/folder.ba5caf35.svg";